/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react';
import { useTheme } from '@emotion/react';
import { CheckboxProps, FormControlLabel, Checkbox as MuiCheckbox } from '@mui/material';

type InputProps = {
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void,
  checked?: boolean,
  props?: CheckboxProps,
  children?: string,
  marginRight?: number,
  name?: string,
  icon?: React.ReactNode,
  checkedIcon?: React.ReactNode,
  size?: number,
};


export default function Checkbox({ props, name, checked, onChange, children, marginRight, icon, checkedIcon, size }: InputProps): JSX.Element {
  const theme = useTheme();
  return (
    <FormControlLabel
      label={children}
      sx={
        {
          marginRight: marginRight + 'px' || 16 + 'px',
          '& .MuiTypography-root': {
            fontFamily: 'Mulish',
            fontSize: '12px',
            lineHeight: '15px',
            color: theme.colors.primaryTextColor,
          },
        }
      }
      control={
        <MuiCheckbox
          checked={checked}
          onChange={onChange}
          name={name}
          onClick={(e) => e.stopPropagation()}
          icon={icon}
          checkedIcon={checkedIcon}
          sx={{
            color: theme.colors.black + '80',
            '&.Mui-checked svg path': {
              color: theme.colors.primaryColor,
            },
            '& .MuiSvgIcon-root': {
              fontSize: size?.toString() + 'px' || '16px',
            },
          }}
          {...props}
        />
      }
    />
  );
}

